module.exports = __webpack_public_path__ + "files/0987cb6383d322cd0be1cd64e0e35b4c.png";